import { mergeAll } from 'lodash/fp'

import scorm from './scorm.actions'
import scormPackage from './scormPackage.actions'

export default mergeAll([scorm, scormPackage])
